import {define, type, attr, Collection, Record} from 'type-r';
import AccrualModel from "./AccrualModel";
import StreetModel from "./StreetModel";

@define
class LandPlotModel extends Record {
    @attr location: string;
    @attr(String.has.toJSON(false)) address: string;
    @attr(StreetModel.from('~streetsRO')) street: StreetModel;
    @attr electric_account: string;
    @attr electric_meter_id: string;
    @attr trash_account: string;
    @attr internet_account: string;
    @attr plot_size: number;
    @attr inventory_plot_number: string;
    @attr(String.has.toJSON(false)) create_date: Date;

}

export default LandPlotModel;


// WEBPACK FOOTER //
// ./src/models/LandPlotModel.ts